/* eslint-disable no-unused-vars */
import React, { lazy, Suspense } from 'react';
import { Spin } from 'antd';
import { Switch, Route, Redirect } from 'react-router-dom';
import { PulseLoader } from 'react-spinners';
import AuthLayout from '../container/profile/authentication/Index';
// import NotFound from '../container/pages/404';

const Login = lazy(() => import('../container/profile/authentication/overview/SignIn'));
const SignUp = lazy(() => import('../container/profile/authentication/overview/Signup'));
const FbLogin = lazy(() => import('../container/profile/authentication/overview/FbSignIn'));
const FbSignUp = lazy(() => import('../container/profile/authentication/overview/FbSignup'));
const ForgotPass = lazy(() => import('../container/profile/authentication/overview/ForgotPassword'));
const NotFound = lazy(() => import('../container/pages/404'));

const FrontendRoutes = () => {
  return (
    <Suspense
      fallback={
        <div className="spin">
          <PulseLoader color="#4285f4" loading size={15} aria-label="Loading Spinner" data-testid="loader" />
        </div>
      }
    >
      <Switch>
        <Route exact path="/" component={Login} />
        <Route path="/forgot-password" component={ForgotPass} />
        <Route path="/register" component={SignUp} />
        <Route path="/fbRegister" component={FbSignUp} />
        <Route path="/fbSignIn" component={FbLogin} />
        <Route path="/fbSignIn" component={FbLogin} />
        <Route component={Login} />
      </Switch>
    </Suspense>
  );
};

export default AuthLayout(FrontendRoutes);
